import { TimeAgo } from '@/components/time-ago';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { TFunction } from 'i18next';
import { DependencyAudience } from './types';
import { DependencyAudienceTotalUsersColumn } from './columns';

const columnHelper = createColumnHelper<DependencyAudience>();

export const getAudiencesTableColumns = (t: TFunction) =>
  [
    columnHelper.accessor('name', {
      id: 'name',
      header: () => t('audiences:table.audience_name'),
      cell: ({ row }) => <p className='text-xs font-medium text-primary-900'>{row.original.name}</p>,
      minSize: 550,
      maxSize: 550,
    }),
    columnHelper.accessor('id', {
      id: 'id',
      header: () => t('audiences:table.id'),
      cell: ({ row }) => <p className='text-xs text-tertiary-600'>{row.original.id}</p>,
      minSize: 130,
      maxSize: 130,
      meta: {
        align: 'center',
      },
    }),
    columnHelper.accessor('createdOn', {
      id: 'createdOn',
      header: () => t('audiences:table.change'),
      cell: ({ getValue }) => <TimeAgo time={getValue()} />,
      minSize: 150,
      maxSize: 150,
      meta: {
        className: () => 'text-tertiary-600',
      },
    }),
    columnHelper.display({
      id: 'size',
      header: () => t('audiences:table.total_users'),
      cell: ({ row }) => <DependencyAudienceTotalUsersColumn audienceId={row.original.id} />,
      minSize: 120,
      maxSize: 120,
      meta: {
        align: 'center',
        nestedClassName: () => 'w-full flex',
      },
    }),
  ] as ColumnDef<DependencyAudience>[];
